import {apiPost} from './api';

export default class ServicioRecepcionDAO {
    static reporte() {
      return apiPost('/recepcion/DAO/Reporte', {
        //CodigoBarras: codigoBarras,
      });
    }

    static historialCambios(datos) {
      return apiPost("/recepcion/DAO/HistorialCambios", datos);
    }

    static consultarFolio(datos) {
      return apiPost("/recepcion/DAO/ConsultarFolio", datos);
    }

    static crear(datos) {
        return apiPost("/recepcion/DAO/Crear", datos);
    }
    
    static obtenerInfo_OpenPay(datos) {
        return apiPost("/openpay/Folio", datos);
    }

    static recepcionLaboratorio(datos) {
        return apiPost("/recepcion/DAO/Laboratorio", datos);
    } 

    static actualizarFechaRecepcion(datos) {
      return apiPost("/recepcion/DAO/Actualizar/FechaRecepcion", datos);
    }

    static actualizarFechaMuestra(datos) {
      return apiPost("/recepcion/DAO/Actualizar/FechaMuestra", datos);
    } 

}